module.exports = "pegasus/assets/tech/medium/1.jpg";